module.exports = __webpack_public_path__ + "static/media/01.611d2c0b.jpg";